/* eslint-disable */
class Helper {
  updateTransform(current, target, speed) {
    let px = current.x + (target.x - current.x) / speed;
    let py = current.y + (target.y - current.y) / speed;
    let pz = current.z + (target.z - current.z) / speed;

    return new BABYLON.Vector3(px, py, pz);
  }

  getPlanetName(distance) {
    let name = "";

    switch (distance) {
      case 0:
        name = "Moon";
        break;
      case 1:
        name = "Mars";
        break;
      case 2:
        name = "Venus";
        break;
      case 3:
        name = "Jupiter";
        break;
      case 4:
        name = "Saturn";
        break;
    }

    return name;
  }

  getPlanetPosition(distance) {
    let y = 0;

    switch (distance) {
      case 0:
        y = 500000 / 5000;
        break;
      case 1:
        y = 2000000 / 5000;
        break;
      case 2:
        y = 4000000 / 5000;
        break;
      case 3:
        y = 7500000 / 5000;
        break;
      case 4:
        y = 12500000 / 5000;
        break;
    }

    return y;
  }
}
export default new Helper();
